module.exports = __webpack_public_path__ + "img/real_land_0.1e77731a.png";